import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-addressedit',
  templateUrl: './addressedit.component.html',
  styleUrls: ['./addressedit.component.css']
})
export class AddresseditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/addressedit/addressedit.component.ts